import React from "react";
import styled from "styled-components";
import moment from "moment";

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { ReactComponent as TrashIcon } from '../../image/Trash.svg';
import { ReactComponent as TermsIcon } from '../../image/TermsIcon.svg';

export default function ContractCard(props) {
  const {
    data,
    index,
    onClickCard,
    onClickDelete,
    onClickToggleStatus
  } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const isEmpty = data === undefined;

  // 카드 본체 클릭시 //
  function onClickBody() {
    onClickCard(data);
  }

  // 휴지통 클릭시 (카드 본체 이벤트 차단) //
  function onClickDeleteButton(e) {
    e.stopPropagation();
    onClickDelete(data);
  }

  // 토글 클릭시 (카드 본체 이벤트 차단) //
  function onClickToggle(e) {
    e.stopPropagation();
    onClickToggleStatus(index);
  }

  if (isEmpty) {
    return (
      <EmptyCardWrapper onClick={onClickBody}>
        <PlusWrapper>
          <PlusStick width={68} height={6} backgroundColor={theme.line} />
          <PlusStick width={6} height={68} backgroundColor={theme.line} />
        </PlusWrapper>
      </EmptyCardWrapper>
    );
  }

  return (
    <CardWrapper onClick={onClickBody}>
      <ImageArea>
        <DocumentImage />
        <DeleteButton onClick={onClickDeleteButton}>
          <TrashSvg />
        </DeleteButton>
      </ImageArea>
      <InfoArea>
        <InfoTextWrapper>
          <TitleText fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{data.title}</TitleText>
          <DateText fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text}>{t('myStoreSetting.terms.modifiedDate') + moment(data.modifiedDate).format(t('myStoreSetting.terms.dateFormat'))}</DateText>
        </InfoTextWrapper>
        <ToggleBox status={data.status} onClick={onClickToggle}>
          <ToggleKnob status={data.status} />
        </ToggleBox>
      </InfoArea>
    </CardWrapper>
  );
}

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 270px;
  height: 150px;

  border-radius: 10px;

  overflow: hidden;

  filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1));

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ImageArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-end;

  padding: 10px 10px 0px 20px;

  width: calc(100% - 30px);
  flex: 1 0 0;
  min-height: 0;

  background-color: ${props => props.theme.background};
`;

const DocumentImage = styled(TermsIcon)`
  width: 70px;
  height: 84px;

  & path {
    fill: ${props => props.theme.line};
  }
`;

const DeleteButton = styled.div`
  position: absolute;

  top: 0;
  right: 0;

  width: 20px;
  height: 20px;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 6.5px;

  border-bottom-left-radius: 5px;

  background-color: ${props => props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRedAlpha20};
    }
  }
`;

const TrashSvg = styled(TrashIcon)`
  width: 20px;
  height: 20px;

  & path {
    fill: ${props => props.theme.white};
  }
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;

  gap: 5px;

  width: calc(100% - 30px);
  height: 56px;

  background-color: ${props => props.theme.buttonFill};

  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  flex: 1 0 0;
  min-width: 0;

  gap: 2px;
`;

const ToggleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 64px;
  height: 32px;

  border: 1px solid ${props => props.status ? `transparent` : props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.status ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ToggleKnob = styled.div`
  margin-left: ${props => props.status ? `36px` : `3px`};

  width: 25px;
  height: 25px;

  border: 1px solid ${props => props.status ? props.theme.primaryAlpha20 : `transparent`};
  border-radius: 8px;
  background-color: ${props => props.status ? props.theme.white : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const EmptyCardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 267px;
  height: 150px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 68px;
  height: 68px;
`;

const PlusStick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 20px;
  background-color: ${props => props.backgroundColor};
`;

const TitleText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0;

  width: 100%;

  color: ${props => props.color};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DateText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0;

  color: ${props => props.color};
`;
